import React, { useEffect, useState } from "react";
import { PaymentFailedIcon } from "staysure-component-library";

import LabelButtonWrapper from "@/components/atoms/button-wrapper/button-wrapper";
import { APPLICATION } from "@/constants";
import useMediaQuery from "@/hooks/use-media-query/use-media-query";
import { PaymentType } from "@/types/payment-types";

function PaymentModalContent(props: Readonly<PaymentType>) {
  const {
    ModalTitle,
    ModalContent,
    ModalButton,
    setIsOpen,
    isEnableSecondaryButton,
  } = props;
  const isDesktop = useMediaQuery("(min-width: 904px)");
  const isTablet = useMediaQuery("(min-width: 600px)");
  const isMobile = useMediaQuery("(min-width: 304px)");

  const [iconSize, setIconSize] = useState({ width: 72, height: 72 });

  useEffect(() => {
    if (isDesktop) {
      setIconSize({ width: 80, height: 80 });
    } else if (isTablet) {
      setIconSize({ width: 72, height: 72 });
    } else if (isMobile) {
      setIconSize({ width: 64, height: 64 });
    }
  }, [isMobile, isTablet, isDesktop]);

  return (
    <div
      className="  lg:py-spacing-5xl lg:px-spacing-6xl md:p-spacing-xxl p-spacing-l flex-col items-center justify-items-center"
      data-testid="paymentModalContent-testid"
    >
      <div
        className={` items-center  justify-center flex ${
          APPLICATION === "renewal"
            ? "[&>svg>rect]:fill-surface-accent-1-primary [&>svg>path:nth-child(3)]:fill-surface-accent-1-primary"
            : ""
        }`}
      >
        <PaymentFailedIcon width={iconSize.width} height={iconSize.height} />
      </div>
      <div className="my-spacing-l md:my-spacing-xl lg:my-spacing-xl">
        <div className=" mb-spacing-m">
          <h1 className=" font-header-font w-[287px] md:w-[346px] mx-[-10px] md:mx-auto lg:w-[348px] items-center text-[26px] md:text-[39px] leading-[29.9px] md:leading-[44.85px] text-center text-text-title align-middle ">
            {ModalTitle}
          </h1>
        </div>
        <div className="max-[54px] justify-between  leading-[27px]">
          <p className="font-body-font text-[18px] text-center  text-[#2E2E2E] leading-[27px] ">
            {ModalContent}
          </p>
        </div>
      </div>
      <div className="h-xxl !w-full">
        <LabelButtonWrapper
          data-testid="payment-modal-content-button"
          id="payment-modal-content-button"
          isDisabled={false}
          className="!w-full"
          label={ModalButton ?? ""}
          hierarchy="primary"
          type="button"
          onClick={() => {
            setIsOpen(false);
          }}
        />
      </div>
      {isEnableSecondaryButton && props?.secondaryButtonLabel && (
        <div className="mt-spacing-l md:mt-spacing-xl h-xxl !w-full">
          <LabelButtonWrapper
            data-testid="payment-modal-content-button"
            id="payment-modal-content-secondary-button"
            isDisabled={false}
            className="!w-full"
            label={props?.secondaryButtonLabel ?? ""}
            hierarchy="secondary"
            type="button"
            onClick={props?.secondaryButtonAction}
          />
        </div>
      )}
    </div>
  );
}

export default PaymentModalContent;
